<template>
  <el-card shadow="never" v-loading="loading">
    <div class="form-container">
      <div class="bg-illustration">
        <svg
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 212 35"
          xml:space="preserve"
        >
          <path
            d="M129.6,7.7c-2.3,0-4.5,1-5.9,2.5V8.5c0-0.2-0.1-0.3-0.3-0.3h-4.6c-0.2,0-0.3,0.1-0.3,0.3v25.6
	c0,0.2,0.2,0.3,0.3,0.3h4.5c0.2,0,0.3-0.2,0.3-0.3v-8.9c1.4,1.5,3.4,2.3,5.5,2.3c5.2,0,9-4.2,9-9.9C138.2,11.7,134.6,7.7,129.6,7.7
	 M132.7,19.1c-0.4,1.7-1.8,3-3.4,3.3c-1.8,0.4-3.4-0.1-4.6-1.3c-1.2-1.3-1.6-3.2-1.1-5.1c0.4-1.7,1.8-3,3.4-3.3
	c0.4-0.1,0.8-0.1,1.1-0.1c1.3,0,2.5,0.5,3.4,1.4C132.8,15.3,133.2,17.2,132.7,19.1"
            fill="#FFF"
            fill-rule="evenodd"
          ></path>
          <path
            d="M15.3,16c3.8-1.5,5.7-4.1,5.7-7.7c0-4.7-3.6-7.6-9.3-7.6H0.9C0.7,0.7,0.6,0.8,0.6,1v25.6c0,0.2,0.1,0.3,0.3,0.3
	h4.8c0.2,0,0.3-0.1,0.3-0.3V16.5h3.6l5.8,10.3c0.1,0.1,0.2,0.2,0.3,0.2H21c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0-0.3L15.3,16z
	 M15.6,8.6c0,2.5-2.1,3.1-3.9,3.1H5.9V5.6h5.7C13.5,5.6,15.6,6.1,15.6,8.6z"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M78.3,0.7h-4.6c-0.2,0-0.3,0.1-0.3,0.3v8.8c-1.2-1.4-3.1-2.1-5.3-2.1c-4.4,0-9.1,3.5-9.1,9.9
	c0,5.8,3.8,9.9,9.1,9.9c2.5,0,4.3-1.1,5.3-2.4v1.6c0,0.2,0.1,0.3,0.3,0.3h4.6c0.2,0,0.3-0.1,0.3-0.3V1C78.6,0.8,78.5,0.7,78.3,0.7
	 M73.8,17.6c0,2.9-2,5-4.8,5c-2.8,0-4.8-2.1-4.8-5s2-5,4.8-5C71.8,12.6,73.8,14.7,73.8,17.6"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M108.5,11.1C108.5,11.1,108.5,11.1,108.5,11.1c-2.3-0.5-3.8-1-4.7-1.7c-0.1-0.1-0.2-0.1-0.3,0
	c-0.1,0-0.2,0.1-0.2,0.2l-1.7,4.2c-0.1,0.1,0,0.3,0.1,0.4c1.1,0.6,2.8,1,4.2,1.4c4.2,1,5.7,1.8,5.7,3.9c0,1.9-1.7,3.1-4.4,3.1
	c-2.4,0-5.3-1.3-7.3-3.4c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.2,0.2l-1.8,4.4c-0.1,0.1,0,0.3,0.1,0.4c1.5,1.6,4.9,3.3,9.6,3.3
	c6.4,0,9.7-4.1,9.7-8.2C117.1,14.9,114.3,12.3,108.5,11.1"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M99.6,8.1C99.5,8,99.5,8,99.4,8h-5.2c-0.1,0-0.2,0.1-0.3,0.2l-4.2,11.2L85.4,8.2c0-0.1-0.2-0.2-0.3-0.2H80
	c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.1-0.1,0.2,0,0.3L87,26.8l-0.5,1.3c-0.4,1.1-0.9,1.5-1.7,1.5c-0.5,0-1-0.1-1.5-0.4
	c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.2,0.2l-0.7,4.3c0,0.1,0,0.3,0.2,0.4c0.7,0.3,1.7,0.4,2.6,0.4c3,0,4.9-1.4,6.2-4.6l8.5-21.5
	C99.7,8.3,99.7,8.2,99.6,8.1"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M30.4,7.7c-5.6,0-9.7,4.2-9.7,9.9c0,5.6,4.1,9.9,9.5,9.9c4.2,0,7.2-1.7,8.9-5c0-0.1,0-0.2,0-0.3
	c0-0.1-0.1-0.1-0.2-0.2l-4-1.3c-0.1,0-0.3,0-0.3,0.1c-1.1,1.4-2.5,2.1-4.3,2.1c-2.4,0-4.2-1.5-4.6-3.9h13.5c0.2,0,0.3-0.1,0.3-0.3
	V17C39.5,11.5,35.8,7.7,30.4,7.7 M30.3,11.8c2.2,0,3.8,1.1,4.3,3.1h-8.7C26.6,13,28.3,11.8,30.3,11.8"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M186,7.7c-5.6,0-9.7,4.2-9.7,9.9c0,5.6,4.1,9.9,9.5,9.9c4.2,0,7.2-1.7,8.9-5c0-0.1,0-0.2,0-0.3
	c0-0.1-0.1-0.1-0.2-0.2l-4-1.3c-0.1,0-0.3,0-0.3,0.1c-1.1,1.4-2.5,2.1-4.3,2.1c-2.4,0-4.2-1.5-4.6-3.9h13.5c0.2,0,0.3-0.1,0.3-0.3
	V17C195.1,11.5,191.4,7.7,186,7.7z M181.5,14.8c0.8-1.9,2.4-3.1,4.4-3.1c2.2,0,3.8,1.1,4.3,3.1H181.5z"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M175.7,22.2l-4.3-1.4c-0.1,0-0.3,0-0.3,0.1c-0.9,1.2-2,1.7-3.6,1.7c-2.7,0-4.5-2-4.5-5c0-2.9,1.8-5,4.5-5
	c1.4,0,2.4,0.4,3.2,1.4c0.1,0.1,0.2,0.1,0.3,0.1l4.5-1.5c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0-0.2,0-0.3c-1.4-3-4.2-4.5-8.2-4.5
	c-5.6,0-9.7,4.3-9.7,9.9c0,5.7,4.1,9.9,9.7,9.9c3.7,0,6.4-1.6,8.4-4.8c0-0.1,0.1-0.2,0-0.3C175.9,22.3,175.8,22.2,175.7,22.2"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M57.4,22.1v-7.6c0-4.5-2.8-6.9-8.2-6.9c-2.3,0-4.3,0.6-5.8,1.8c-1.3,1.1-2.1,2.6-2.1,4.1c0,0.2,0,0.4,0,0.5
	c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1l4.3-0.5c0.2,0,0.3-0.2,0.3-0.3c0-0.5,0.1-0.9,0.4-1.2c0.5-0.5,1.4-0.8,2.5-0.8
	c2,0,3,0.8,3,2.4v0.4l-5.1,0.8c-4.2,0.6-6.7,2.9-6.7,6.3c0,3.6,2.5,6,6.3,6c2.4,0,4.5-1,5.8-2.8c0.2,1.2,0.6,1.9,0.9,2.2
	c0.1,0.1,0.1,0.1,0.2,0.1h4.6c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0-0.2,0-0.3C57.7,25.2,57.4,24.1,57.4,22.1z M52.2,18.2
	c0,3-1.7,4.9-4.4,4.9c-0.9,0-2.4-0.2-2.4-1.9c0-1.3,0.9-2.1,2.8-2.4L52.2,18.2z"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M205.2,15.2C205.2,15.2,205.2,15.2,205.2,15.2c-2.7-0.6-4-1.3-4-2.3c0-1.2,1.8-1.3,2.4-1.3
	c1.3,0,2.5,0.5,3.3,1.6c0.1,0.1,0.2,0.1,0.3,0.1L211,12c0.1,0,0.2-0.1,0.2-0.2c0-0.1,0-0.2,0-0.3c-1.7-2.9-3.7-3.9-7.6-3.9
	c-1.9,0-3.6,0.5-4.8,1.4c-1.4,1-2.2,2.5-2.2,4.2c0,3.1,2.2,5.1,6.5,6c2.6,0.5,3.6,1.1,3.6,2c0,1.1-1.3,1.7-2.5,1.7
	c-1.7,0-3.1-0.8-4.2-2.3c-0.1-0.1-0.2-0.2-0.3-0.1l-4.2,1.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0.2,0,0.3c2,3.4,4.8,5.1,8.8,5.1
	c4.4,0,7.4-2.6,7.4-6.4C211.4,17.9,209.5,16.1,205.2,15.2"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M105.6,5.2C105.6,5.2,105.6,5.2,105.6,5.2c2.8,0,4.8,0.7,6.2,2.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0
	l4-2.3c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2-0.1-0.2c-2-2.4-5.5-4-9-4.1c-0.1,0-0.2,0.1-0.3,0.2l-1.7,4.1c0,0.1,0,0.2,0,0.3
	C105.4,5.1,105.5,5.2,105.6,5.2"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
          <path
            d="M156.2,22.1v-7.6c0-4.5-2.8-6.9-8.2-6.9c-2.3,0-4.3,0.6-5.8,1.8c-1.3,1.1-2.1,2.6-2.1,4.1c0,0.2,0,0.5,0,0.5
	c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1l4.3-0.5c0.2,0,0.3-0.2,0.3-0.3c0-0.5,0.1-0.9,0.4-1.2c0.5-0.5,1.4-0.8,2.5-0.8
	c2,0,3,0.8,3,2.4v0.4l-5.1,0.8c-4.2,0.6-6.7,2.9-6.7,6.3c0,3.6,2.5,6,6.3,6c2.4,0,4.5-1,5.8-2.8c0.2,1.2,0.6,1.9,0.9,2.2
	c0.1,0.1,0.1,0.1,0.2,0.1h4.6c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0-0.2,0-0.3C156.4,25.2,156.2,24.1,156.2,22.1z M151,18.2
	c0,3-1.7,4.9-4.4,4.9c-0.9,0-2.4-0.2-2.4-1.9c0-1.3,0.9-2.1,2.8-2.4L151,18.2z"
          fill="#FFF"
          fill-rule="evenodd"
          ></path>
        </svg>
      </div>

      <header :class="!cardType ? 'header-slide' : ''">
        <h1 v-if="!cardType">Card Form</h1>
      </header>

      <form id="my-sample-form" class="scale-down" :class="cardType">
        <div class="cardinfo-card-number">
          <label class="cardinfo-label" for="card-number">Card Number</label>
          <div class="input-wrapper" id="card-number"></div>
          <div id="card-image" :class="cardType"></div>
        </div>

        <div class="cardinfo-wrapper">
          <div class="cardinfo-exp-date">
            <label class="cardinfo-label" for="expiration-date"
              >Valid Thru</label
            >
            <div class="input-wrapper" id="expiration-date"></div>
          </div>

          <div class="cardinfo-cvv">
            <label class="cardinfo-label" for="cvv">CVV</label>
            <div class="input-wrapper" id="cvv"></div>
          </div>
        </div>

        <div class="cardinfo-wrapper">
          <div class="cardinfo-postal-code">
            <label class="cardinfo-label" for="postal-code">Postal Code</label>
            <div id="postal-code" class="input-wrapper"></div>
          </div>
        </div>
      </form>

      <input
        @click="submitForm"
        :disabled="isDisabled"
        class="show-button"
        id="button-pay"
        type="submit"
        value="Continue"
      />
    </div>
  </el-card>
</template>

<script>
import axios from 'axios';
import { PG_API_BASE } from '../env';

export default {
  props: { customerId: { type: String, required: true } },
  data() {
    return {
      hostedFieldsInstance: null,
      cardType: '',
      loading: false,
      isDisabled: true,
    };
  },
  name: 'CreditCardForm',
  async mounted() {
    // eslint-disable-next-line global-require
    const braintree = require('braintree-web/client');
    // eslint-disable-next-line global-require
    const hostedFields = require('braintree-web/hosted-fields');

    const response = await axios.get(`${PG_API_BASE}/client/token`, {
      headers: {
        Authorization: `Bearer ${this.$keycloak.token}`,
      },
    });

    try {
      const clientInstance = await braintree.create({
        authorization: response.data.token.clientToken,
      });
      try {
        const hostedFieldsInstance = await hostedFields.create({
          client: clientInstance,
          styles: {
            input: {
              color: '#282c37',
              'font-size': '16px',
              transition: 'color 0.1s',
              'line-height': '3',
            },
            // Style the text of an invalid input
            'input.invalid': {
              color: '#E53A40',
            },
            // placeholder styles need to be individually adjusted
            '::-webkit-input-placeholder': {
              color: 'rgba(0,0,0,0.6)',
            },
            ':-moz-placeholder': {
              color: 'rgba(0,0,0,0.6)',
            },
            '::-moz-placeholder': {
              color: 'rgba(0,0,0,0.6)',
            },
            ':-ms-input-placeholder': {
              color: 'rgba(0,0,0,0.6)',
            },
            // prevent IE 11 and Edge from
            // displaying the clear button
            // over the card brand icon
            'input::-ms-clear': {
              opacity: '0',
            },
          },
          // Add information for individual fields
          fields: {
            number: {
              selector: '#card-number',
              placeholder: '1111 1111 1111 1111',
            },
            cvv: {
              selector: '#cvv',
              placeholder: '123',
            },
            expirationDate: {
              selector: '#expiration-date',
              placeholder: `10 / ${new Date().getFullYear()}`,
            },
            postalCode: {
              selector: '#postal-code',
              placeholder: '11231',
            },
          },
        });
        hostedFieldsInstance.component = this;
        this.hostedFieldsInstance = hostedFieldsInstance;
        hostedFieldsInstance.on('validityChange', (event) => {
          // Check if all fields are valid, then show submit button
          const formValid = Object.keys(event.fields).every(
            key => event.fields[key].isValid,
          );

          if (formValid) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
        });

        hostedFieldsInstance.on('blur', (event) => {
          const state = hostedFieldsInstance.getState();
          if (!state.fields.number.isValid) {
            this.$message.warning({
              title: 'Warning',
              message: 'Invalid Card Number',
            });
            return;
          }

          if (!state.fields.cvv.isValid) {
            this.$message.warning({
              title: 'Warning',
              message: 'Invalid CVV',
            });
            return;
          }

          if (!state.fields.expirationDate.isValid) {
            this.$message.warning({
              title: 'Warning',
              message: 'Invalid Expiration Date',
            });
            return;
          }

          if (!state.fields.postalCode.isValid) {
            this.$message.warning({
              title: 'Warning',
              message: 'Invalid Post code',
            });
          }
        });


        hostedFieldsInstance.on('empty', () => {
          hostedFieldsInstance.component.cardType = null;
          // $('header').removeClass('header-slide');
          // $('#card-image').removeClass();
          // $(form).removeClass();
        });

        hostedFieldsInstance.on('cardTypeChange', (event) => {
          // Change card bg depending on card type
          if (event.cards.length === 1) {
            hostedFieldsInstance.component.cardType = event.cards[0].type;
            // $(form).removeClass().addClass(event.cards[0].type);
            // $('#card-image').removeClass().addClass(event.cards[0].type);
            // $('header').addClass('header-slide');

            // Change the CVV length for AmericanExpress cards
            if (event.cards[0].code.size === 4) {
              hostedFieldsInstance.setAttribute({
                field: 'cvv',
                attribute: 'placeholder',
                value: '1234',
              });
            }
          } else {
            hostedFieldsInstance.setAttribute({
              field: 'cvv',
              attribute: 'placeholder',
              value: '123',
            });
          }
        });
      } catch (err) {
        if (err) {
          console.error(err);
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    clearFields() {
      this.hostedFieldsInstance.clear('number');
      this.hostedFieldsInstance.clear('cvv');
      this.hostedFieldsInstance.clear('expirationDate');
      this.hostedFieldsInstance.clear('postalCode');
    },
    async submitForm(event) {
      event.preventDefault();

      try {
        this.loading = true;
        const nonceResponse = await this.hostedFieldsInstance.tokenize();
        await this.saveCard(nonceResponse.nonce);
        this.$emit('added-card');
        this.clearFields();
        this.$message.success({
          message: 'Sucessfully added card',
        });
        this.loading = false;
      } catch (err) {
        this.loading = false;
        let message = err.message;
        if (message ===  'Credit card type is not accepted by this merchant account.') {
          message = 'Error: Only Visa and Mastercard are accepted.';
        }
        this.$message.warning({
          title: 'Invalid Credit Card',
          message,
        });
        this.clearFields();
      }
    },
    async saveCard(nonce) {
      const response = await axios.post(
        `${PG_API_BASE}/customer/create/payment`,
        {
          customerId: this.customerId,
          paymentMethodNonce: nonce,
          options: {
            verifyCard: true,
            verificationAmount: '0.10',
          },
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      if (!response.data.result.success) {
        throw new Error(response.data.result.message);
      }
      return response.data.result;
    },
  },
};
</script>

<style scoped>
/*-------------------- General --------------------*/
html,
body {
  font-size: 100%;
  height: 100%;
  color: #282c37;
  font-family: sans-serif;
  padding: 0;
  margin: 0;
}
header {
  z-index: 2;
  transform: translate(0, 5.5em);
  transition: all 0.5s ease;
}
header.header-slide {
  transform: translate(0, 0);
}
h1 {
  font-weight: 100;
  font-size: 1.4em;
  display: block;
}
.form-container {
  display: flex;
  background-color: #009aca;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
  border: 1em solid #fff;
  box-sizing: border-box;
  position: relative;
}
@media (max-width: 476px) {
  .form-container {
    border: none;
  }
}
.cardinfo-wrapper {
  display: flex;
  justify-content: space-around;
}
.bg-illustration {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 0;
}
.bg-illustration svg {
  width: 100%;
}
.card-shape,
#my-sample-form.visa,
#my-sample-form.master-card,
#my-sample-form.maestro,
#my-sample-form.american-express,
#my-sample-form.discover,
#my-sample-form.unionpay,
#my-sample-form.jcb,
#my-sample-form.diners-club {
  border-radius: 6px;
  padding: 2em 2em 1em;
}
@media (max-width: 476px) {
  .card-shape,
  #my-sample-form.visa,
  #my-sample-form.master-card,
  #my-sample-form.maestro,
  #my-sample-form.american-express,
  #my-sample-form.discover,
  #my-sample-form.unionpay,
  #my-sample-form.jcb,
  #my-sample-form.diners-club {
    padding: 2em 1.5em 1em;
  }
}
#my-sample-form {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  padding: 8em 3em 2em;
  width: 20em;
  margin-top: 2em;
  margin-bottom: 2em;
  transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);
  animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
  z-index: 1;
  opacity: 0.9;
}
#my-sample-form:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
}
@media (max-width: 476px) {
  #my-sample-form {
    box-sizing: border-box;
    padding: 7em 2em 2em;
    width: 100%;
  }
}
#my-sample-form.visa {
  color: #fff;
  background-color: #0d4aa2;
}
#my-sample-form.master-card {
  color: #fff;
  background-color: #363636;
  background: linear-gradient(
    115deg,
    #d82332,
    #d82332 50%,
    #f1ad3d 50%,
    #f1ad3d
  );
}
#my-sample-form.maestro {
  color: #fff;
  background-color: #363636;
  background: linear-gradient(
    115deg,
    #009ddd,
    #009ddd 50%,
    #ed1c2e 50%,
    #ed1c2e
  );
}
#my-sample-form.american-express {
  color: #fff;
  background-color: #007cc3;
}
#my-sample-form.discover {
  color: #fff;
  background-color: #ff6000;
  background: linear-gradient(#d14310, #f7961e);
}
#my-sample-form.unionpay,
#my-sample-form.jcb,
#my-sample-form.diners-club {
  color: #fff;
  background-color: #363636;
}
.cardinfo-label {
  display: block;
  font-size: 11px;
  margin-bottom: 0.5em;
  text-transform: uppercase;
}
.cardinfo-exp-date {
  margin-right: 1em;
  width: 100%;
}
.cardinfo-cvv {
  width: 100%;
}
#button-pay:enabled {
  cursor: pointer;
  width: 16em;
  font-size: 15px;
  border: 0;
  padding: 1.2em 1em;
  margin-bottom: 1em;
  color: #fff;
  background: #282c37;
  border-radius: 4px;
  z-index: 0;
  transform: translateY(-100px);
  transition: all 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
  opacity: 0.1;
  -webkit-appearance: none;
}
#button-pay:disabled {
  color: #fff;
  cursor: not-allowed;
  width: 16em;
  font-size: 15px;
  border: 0;
  padding: 1.2em 1em;
  margin-bottom: 1em;
  background: #282c37;
  border-radius: 4px;
  z-index: 0;
  transform: translateY(-100px);
  transition: all 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
  opacity: 0.1;
  -webkit-appearance: none;
}
#button-pay:hover {
  background: #616777;
}
#button-pay:active {
  animation: cardIntro 200ms cubic-bezier(0.2, 1.3, 0.7, 1);
}
#button-pay.show-button {
  transform: translateY(0);
  opacity: 1;
}
.cardinfo-card-number {
  position: relative;
}
#card-image {
  position: absolute;
  top: 2em;
  right: 1em;
  width: 44px;
  height: 28px;
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/346994/card_sprite.png);
  background-size: 86px 458px;
  border-radius: 4px;
  background-position: -100px 0;
  background-repeat: no-repeat;
  margin-bottom: 1em;
}
#card-image.visa {
  background-position: 0 -398px;
}
#card-image.master-card {
  background-position: 0 -281px;
}
#card-image.american-express {
  background-position: 0 -370px;
}
#card-image.discover {
  background-position: 0 -163px;
}
#card-image.maestro {
  background-position: 0 -251px;
}
#card-image.jcb {
  background-position: 0 -221px;
}
#card-image.diners-club {
  background-position: 0 -133px;
}
/*-------------------- Inputs --------------------*/
.input-wrapper {
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.86);
  height: 2.75em;
  border: 1px solid #eee;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
  padding: 5px 10px;
  margin-bottom: 1em;
}
.cardinfo-card-number,
.cardinfo-exp-date,
.cardinfo-postal-code,
.cardinfo-cvv {
  transition: transform 0.3s;
}
.braintree-hosted-fields-focused {
  border-color: #5db6e8;
}
.braintree-hosted-fields-invalid {
  border-color: #e53a40;
  animation: shake 500ms cubic-bezier(0.2, 1.3, 0.7, 1) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
/*-------------------- Animations --------------------*/
@keyframes cardIntro {
  0% {
    transform: scale(0.8) translate(0, 0);
    opacity: 0;
  }
  100% {
    transform: scale(1) translate(0, 0);
    opacity: 1;
  }
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(1px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-3px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(3px, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CreditCardForm.vue